const base = 'bg-gray-200 animate-pulse rounded';

export const SkeletonLine = ({ className = '' }) => (
  <span className={`block h-3 ${base} ${className}`} aria-hidden="true" />
);

export const SkeletonBox = ({ className = '' }) => (
  <span className={`block ${base} ${className}`} aria-hidden="true" />
);

export const SkeletonBookCard = () => (
  <article
    className="bg-white border border-gray-200 rounded-lg p-3 flex flex-col"
    aria-busy="true"
    aria-label="Loading book"
  >
    <SkeletonBox className="h-48 mb-3" />
    <SkeletonLine className="w-1/3 mb-2" />
    <SkeletonLine className="w-4/5 mb-1" />
    <SkeletonLine className="w-2/3 mb-3" />
    <SkeletonLine className="w-1/2 mb-3" />
    <SkeletonBox className="h-9 mt-auto" />
  </article>
);

export const SkeletonBookGrid = ({ count = 10 }) => (
  <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 list-none">
    {Array.from({ length: count }).map((_, i) => (
      <li key={i}>
        <SkeletonBookCard />
      </li>
    ))}
  </ul>
);

export const SkeletonBookDetail = () => (
  <section
    className="w-full mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-2 gap-8"
    aria-busy="true"
    aria-label="Loading book details"
  >
    <SkeletonBox className="h-96 w-full" />
    <div className="flex flex-col gap-3">
      <SkeletonLine className="w-3/4 h-6" />
      <SkeletonLine className="w-1/2" />
      <SkeletonLine className="w-1/3 h-5 mt-4" />
      <SkeletonLine className="w-full mt-4" />
      <SkeletonLine className="w-full" />
      <SkeletonLine className="w-5/6" />
      <SkeletonLine className="w-4/6" />
      <SkeletonBox className="h-11 w-40 mt-6" />
    </div>
  </section>
);

export default SkeletonBookCard;
